<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'MainBlog'
}
</script>

<style scoped>

</style>
